import { useEmitter } from '@/plugins'
import { ref, computed, onMounted, onUnmounted } from 'vue'

export function usePagination(perPage: number) {

    const emitter = useEmitter();

    const maxPages = ref<number>(0);
    const endIndex = ref<number>(perPage);
    const startIndex = ref<number>(0);
    const currentPage = ref<number>(1);
    const totalPerPage = ref<number>(perPage);

    const canPrevious = computed(() => currentPage.value === 1);
    const canNext = computed(() => maxPages.value === currentPage.value || maxPages.value === 0);

    function nextPage(): void {
        currentPage.value += 1;
        endIndex.value += totalPerPage.value;
        startIndex.value += totalPerPage.value;
    }

    function previousPage(): void {
        currentPage.value -= 1;
        endIndex.value -= totalPerPage.value;
        startIndex.value -= totalPerPage.value;
    }

    onUnmounted(() => emitter.off("update:max-pages"));
    onMounted(() => emitter.on("update:max-pages", (total: number) => maxPages.value = total));

    return {
        startIndex,
        endIndex,
        maxPages,
        canNext,
        canPrevious,
        nextPage,
        previousPage
    };
}